<template>
    <div>
        <crud-table title="الامتحانات" :actions="actions" show-search search-placeholder="ابحث بكود الامتحان أو الاسم" server-pagination :page-count="exams.meta.last_page" :current-page="exams.meta.current_page" :total="exams.meta.total" :per-page="exams.meta.per_page" :items="examsItemsComputed" :headers="headersComputed" @open="openExamPage" @edit="openEditDialog" @delete="openDeleteDialog" @load="loadMore" @create="createDialog =  true" @search="search" @reset="reset" />

        <action-dialog v-model="createDialog" max-width="475" action="post" scrollable :url="`/exams`" success-msg="تم إنشاء الامتحان بنجاح" title="امتحان جديد" button-text="إنشاء" :data="{...newExam, starts_at: starts_at ? toDateTimeString(starts_at) : null, ends_at: ends_at ? toDateTimeString(ends_at) : null}" @reset="resetCreateForm" @sync="openExamPage"> <!-- @sync="addItem" -->
            <v-text-field v-model="newExam.name" autofocus label="اسم الامتحان" placeholder="أدخل اسم الامتحان"></v-text-field>
            <v-select v-model="newExam.type" label="نوع الامتحان" :items="[{text: 'امتحان', value: 'exam'}, {text: 'واجب', value: 'homework'}]"></v-select>
            <v-text-field v-model="newExam.duration" type="number" min="1" suffix="دقيقة" label="وقت الامتحان (اختياري)" placeholder="اترك الحقل فارغاً ليكون الامتحان بلا وقت" hint="بعد مرور الوقت سيتم إنهاء الامتحان إجبارياً"></v-text-field>
            <v-text-field v-model="newExam.pass_percentage" type="number" min="1" prefix="%" label="نسبة النجاح"></v-text-field>
            <v-text-field v-model="newExam.question_mark" type="number" suffix="درجة" label="درجة السؤال الواحد" hint="الدرجة الافتراضية لكل اﻷسئلة لكن يمكنك تعديل درجة سؤال معين لاحقاً"></v-text-field>
            <v-autocomplete v-model="newExam.category_id" clearable label="التصنيف (اختياري)" placeholder="اختر التصنيف" :items="categoriesSelectItems"></v-autocomplete>
            <v-datetime-picker v-model="starts_at" label="يبدأ في (اختياري)" placeholder="اﻵن" ok-text="تأكيد" clear-text="إلغاء" :timePickerProps="{'ampm-in-title': true, scrollable: true, color: 'primary', headerColor: 'primary'}" :datePickerProps="{min: today, locale: 'ar', color: 'primary', headerColor: 'primary'}" :text-field-props="{persistentHint: true, hint: 'اترك الحقل فارغاً ليتم السماح بالدخول من اﻵن', class: 'mb-2'}"> </v-datetime-picker>
            <v-datetime-picker v-model="ends_at" label="ينتهي في (اختياري)" placeholder="لا ينتهي" ok-text="تأكيد" clear-text="إلغاء" :timePickerProps="{'ampm-in-title': true, scrollable: true, color: 'primary', headerColor: 'primary'}" :datePickerProps="{min: today, locale: 'ar', color: 'primary', headerColor: 'primary'}" :text-field-props="{persistentHint: true, hint: 'اترك الحقل فارغاً ليتم السماح بالدخول للامتحان دائماً', class: 'mb-2'}"> </v-datetime-picker>
            <v-textarea v-model="newExam.description" rows="3" no-resize label="(اختياري) وصف الامتحان" placeholder="أدخل وصف طويل للامتحان" class="mt-3"></v-textarea>

            <v-checkbox v-model="newExam.show_result" label="عرض النتيجة بعد اﻹنتهاء" color="primary" persistent-hint hint="سيظهر للطالب نتيجته فوراً بعد إنهاء الامتحان"></v-checkbox>
            <v-checkbox v-model="newExam.show_detailed_result" label="عرض نتيجة مفصلة واﻹجابات الصحيحة" color="primary" persistent-hint hint="سيظهر للطالب إجاباته الخاطئة واﻹجابة الصحيحة لكل سؤال"></v-checkbox>
            <v-checkbox v-model="newExam.shuffled_questions" label="ترتيب اﻷسئلة عشوائياً" color="primary" persistent-hint hint="خلط اﻷسئلة بحيث يكون لكل طالب نموذج بترتيب أسئلة مختلف"></v-checkbox>
            <v-checkbox v-model="newExam.shuffled_answers" label="ترتيب اﻹجابات عشوائياً" color="primary" persistent-hint hint="تظهر اﻹجابات بترتيب مختلف لكل طالب"></v-checkbox>
            <v-checkbox v-if="enableImageAnswers" v-model="newExam.enable_images_answers" label="إجابات الصور للأسئلة المقالية" color="primary" persistent-hint hint="السماح للطالب برفع صورة كإجابة للأسئلة المقالية"></v-checkbox>

        </action-dialog>

        <edit-dialog v-model="editDialog" :data="editedItem" :categories="categoriesSelectItems" @sync="syncItem" />


        <action-dialog v-model="deleteDialog" action="delete" :url="`/exams/${deleteExam ? deleteExam.id : ''}`" title="حذف الامتحان" button-text="تأكيد الحذف" button-color="error" @sync="deleteItem(deleteExam.id)">
            <div v-if="deleteExam">
                <p class="strong-text--text">
                    هل أنت متأكد من حذف الامتحان <b class="strong-text--text">"{{deleteExam.name}}"</b> ؟
                </p>
            </div>
        </action-dialog>
    </div>
</template>

<script>
import CrudTable from '@/components/default/crud-table'
import EditDialog from '@/components/custom/edit-dialog'

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    components: {
        CrudTable,
        EditDialog
    },
    props: {
        exams: {},
        categories_select_items: {}
    },
    data() {
        const now = new Date();
        return {
            page_url: '/exams',
            today: now.toISOString().substr(0, 10),

            createDialog: false,
            newExam: {
                name: '',
                type: 'exam',
                duration: '',
                pass_percentage: 50,
                question_mark: 1,
                show_result: true,
                show_detailed_result: false,
                shuffled_questions: true,
                shuffled_answers: false,
                enable_images_answers: false,
                category_id: '',
                description: '',
            },
            starts_at: '',
            ends_at: '',

            editDialog: false,
            editedItem: null,

            deleteDialog: false,
            deleteExam: null,

            examsItems: null,

            headers: [
                {
                    text: 'عمليات',
                    value: 'actions',
                    sortable: false
                },
                /* {
                    text: '#',
                    align: 'start',
                    sortable: false,
                    value: 'id',
                }, */
                {
                    text: 'كود الامتحان',
                    align: 'start',
                    sortable: false,
                    bold: true,
                    value: 'exam_code',
                    cellClass: 'font-weight-bold',
                    show: 'enableGenericExams'
                },
                {
                    text: 'اسم الامتحان',
                    align: 'start',
                    sortable: false,
                    value: 'name',
                    button: 'examUrl',
                    color: 'link'
                },
                {
                    text: 'نوع الامتحان',
                    align: 'center',
                    sortable: false,
                    value: 'type',

                    chip: true,
                    chipFunction: (type)=>{
                        if (type === 'homework'){
                            return {text: 'واجب', color: 'teal', icon: 'mdi-file-question'};
                        }else if (type === 'exam'){
                            return {text: 'امتحان', color: 'primary', icon: 'mdi-clipboard-text'};
                        }else{
                            return {text: type, color: 'primary', icon: 'mdi-clipboard-text'};
                        }
                    },
                },
                {
                    text: 'التصنيف',
                    align: 'center',
                    sortable: false,
                    value: 'categoryName',
                },
                {
                    text: 'مدة الامتحان',
                    align: 'center',
                    sortable: false,
                    value: 'durationText',
                },
                {
                    text: 'عدد الجلسات',
                    align: 'center',
                    sortable: false,
                    value: 'sessions_count',
                    number: true,
                },
                {
                    text: 'عدد اﻷسئلة',
                    align: 'center',
                    sortable: false,
                    value: 'questions_count',
                },
                {
                    text: 'عرض النتيجة',
                    align: 'center',
                    sortable: false,
                    value: 'show_result',
                    boolean: true,
                },
                {
                    text: 'ترتيب عشوائي للأسئلة',
                    align: 'center',
                    sortable: false,
                    value: 'shuffled_questions',
                    boolean: true,
                },
                {
                    text: 'وقت البداية',
                    value: 'starts_at',
                    time: true,
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'وقت الانتهاء',
                    value: 'ends_at',
                    time: true,
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'وقت اﻹنشاء',
                    value: 'created_at',
                    time: true,
                    align: 'center',
                    sortable: false,
                },
            ],
        }
    },
    computed: {
        enableImageAnswers(){
            return this.appData.enable_exam_images_answers;
        },
        headersComputed(){
            return this.headers.filter(header=>{
                return !header.show || this[header.show];
            })
        },
        examsItemsComputed(){
            return this.examsItems.map(exam=>{
                return {
                    ...exam,
                    examUrl: `/exams/${exam.id}`,
                    durationText: exam.duration ? `${exam.duration}:00` : '__',
                    categoryName: exam.category ? exam.category.name : '__',
                }
            });
        },
        categoriesSelectItems(){
            if (this.categories_select_items){
                return this.categories_select_items.map(category=>{
                    return {text: category.name, value: category.id};
                })
            }else{
                return [];
            }
        },
        actions(){
            let actions = [
                {name: 'open', text: 'صفحة الامتحان', icon: 'mdi-open-in-new', color: 'primary'},
                {name: 'edit', text: 'تعديل', icon: 'mdi-pencil', color: 'blue-grey'},
                {name: 'delete', text: 'حذف', icon: 'mdi-delete', color: 'error'},
            ];
            return actions;
        },
        enableGenericExams(){
            return !!this.appData.enable_gen_exm;
        },
        ...GlobalComputed,
    },
    watch: {
        exams(exams){
            this.examsItems = exams.data;
        },
        newExam: {
            deep: true,
            handler(newExam){
                if (newExam.show_detailed_result && !newExam.show_result){
                    window.setTimeout(()=>{
                        newExam.show_result = true;
                    }, 75)
                }
            }
        }
    },
    methods: {
        ...GlobalMethods,
        openExamPage(exam){
            if (exam){
                this.$router.push(`/exams/${exam.id}`);
            }
        },
        loadMore(payload){
            const page = payload.page;
            this.$emit('loadMore', page);
        },
        addItem(item){
            this.examsItems.unshift(item);
        },
        resetCreateForm(){
            Object.assign(this.newExam, {
                name: '',
                description: '',
            });
            this.starts_at = '';
            this.ends_at = '';
        },
        search(query){
            this.$emit('search', query);
        },
        reset(){
            this.$emit('reset');
        },
        openEditDialog(exam){
            this.editedItem = exam;
            this.editDialog = true;
        },
        syncItem(newItem){
            this.examsItems = this.examsItems.map(item=>{
                if (item.id === newItem.id){
                    return Object.assign(item, newItem);
                }
                return item;
            })
        },
        deleteItem(id){
            this.examsItems = this.examsItems.filter(item=>{
                return item.id !== id;
            })
        },
        editAction(){

        },
        openDeleteDialog(exam){
            this.deleteDialog = true;
            this.deleteExam = exam;
        },

    },
    created(){
        this.examsItems = this.exams.data;
    },
    mounted(){
        if (this.enableImageAnswers){
            this.newExam.enable_images_answers = true;
        }
    }
}

</script>
